module.exports = __webpack_public_path__ + "static/media/theme_krimi.c33813f0.jpg";